export const toBase64 = btoa;
export const fromBase64 = atob;
